import React from "react";
import { FaUser } from "react-icons/fa";

const StudentList = ({
  studentMap,
  groupStudentsMap,
  selectedGroups,
  customStudents,
  onRemoveStudent,
  onClearAll,
  showSummaryOnly,
}) => {
  const getStudentGroupLabels = () => {
    const map = {};

    // Handle group-based students
    Object.entries(groupStudentsMap).forEach(([groupId, studentSet]) => {
      const groupLabel = selectedGroups.find((g) => g.value === groupId)?.label;
      if (groupLabel) {
        studentSet.forEach((studentId) => {
          if (!map[studentId]) map[studentId] = [];
          map[studentId].push(groupLabel);
        });
      }
    });

    // ✅ Handle custom students using .value
    customStudents.forEach((student) => {
      const studentId = typeof student === "string" ? student : student.value;
      if (!map[studentId]) map[studentId] = [];
      map[studentId].push("Custom");
    });

    return map;
  };

  const studentGroupsMap = getStudentGroupLabels();
  const sortedStudents = Object.values(studentMap || {}).sort((a, b) =>
    a.stud_name.localeCompare(b.stud_name)
  );

  return (
    <div className="space-y-3">
      {!showSummaryOnly && Object.keys(studentMap).length > 0 && (
        <div className="bg-gray-50 border border-gray-200 rounded-md p-3 mb-3">
          <h4 className="text-sm font-medium text-gray-700 mb-2">
            Students per Year Level
          </h4>
          <div className="flex flex-wrap gap-3">
            {Object.entries(
              Object.values(studentMap || {}).reduce((acc, student) => {
                const year =
                  student.stYrLvl !== undefined && student.stYrLvl !== null
                    ? student.stYrLvl
                    : "Unknown";

                acc[year] = (acc[year] || 0) + 1;
                return acc;
              }, {})
            )
              .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
              .map(([year, count]) => (
                <div
                  key={`summary-${year}`}
                  className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1"
                >
                  {year === "0" || year === 0 ? "Prep" : `Year ${year}`}:{" "}
                  {count}
                  <FaUser className="inline-block text-blue-500 text-[0.75rem]" />
                </div>
              ))}
          </div>
        </div>
      )}
      <div className="flex justify-between items-center">
        <label className="block text-sm font-medium text-gray-700">
          Current Students ({sortedStudents.length})
        </label>
        {sortedStudents.length > 0 && (
          <button
            onClick={onClearAll}
            className="text-sm text-red-500 hover:underline"
          >
            Remove all
          </button>
        )}
      </div>

      <ul className="border border-gray-200 rounded-md p-3 bg-white text-sm space-y-2 max-h-60 overflow-auto">
        {sortedStudents.map((student) => (
          <li
            key={student.stud_code}
            className="flex flex-col sm:flex-row sm:justify-between sm:items-center border-b pb-1"
          >
            <div>
              <div className="font-medium text-gray-800">
                {student.stud_name}
              </div>
              <div className="flex flex-wrap gap-1 mt-1 text-xs text-gray-600">
                {(studentGroupsMap[student.stud_code] || []).map((label) => (
                  <span
                    key={`${student.stud_code}-${label}`}
                    className="bg-gray-200 px-2 py-0.5 rounded-full"
                  >
                    {label}
                  </span>
                ))}
              </div>
            </div>
            <button
              onClick={() => onRemoveStudent(student.stud_code)}
              className="text-red-500 text-xs mt-2 sm:mt-0 sm:ml-4 hover:underline"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default StudentList;
